import { useCallback, useState } from 'react';
import { useQueryClient } from '@common-fe/common-fe';
import { getDuration } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { QUERY_KEY } from './useResendList.query';

interface Params {
  id: string;
  onSuccess: () => void;
  onResendCallback?: () => void;
}
const useResendQuery = ({ onSuccess, onResendCallback, id }: Params) => {
  const queryClient = useQueryClient();
  const [isProcessing, setProcessing] = useState(false);

  const handleResend = useCallback(async () => {
    setProcessing(true);
    if (onResendCallback) {
      onResendCallback();
    }

    await api.post(API_URL.COMMUNICATIONS_RESEND_BY_ID(id));
    queryClient.invalidateQueries({
      queryKey: [QUERY_KEY],
    });
    setTimeout(
      () => {
        setProcessing(false);
        onSuccess();
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY],
        });
      },
      getDuration({ seconds: 15 })
    );
  }, [onSuccess, queryClient, id, onResendCallback]);
  return {
    isProcessing,
    handleResend,
  };
};

export default useResendQuery;
